import html2canvas from 'html2canvas';

const MAP_CAPTURE_HEIGHT = '550px';
const MAP_RESIZE_DELAY_MS = 400;
const MAP_JPEG_QUALITY = 0.9;

// Safari blokuje odczyt zrzutu z ikonami SVG mapy (SecurityError), wtedy bierzemy sam canvas MapLibre — bez pinezek, ale z mapą
export const captureMapImage = async (mapContainer: HTMLElement): Promise<string | undefined> => {
    const originalHeight = mapContainer.style.height;

    try {
        mapContainer.style.height = MAP_CAPTURE_HEIGHT;
        await new Promise((resolve) => setTimeout(resolve, MAP_RESIZE_DELAY_MS));

        try {
            const mapSnapshot = await html2canvas(mapContainer, { allowTaint: true, useCORS: true, scale: window.devicePixelRatio || 1 });

            return mapSnapshot.toDataURL('image/jpeg', MAP_JPEG_QUALITY);
        } catch {
            const mapCanvas = mapContainer.querySelector('canvas');

            return mapCanvas ? mapCanvas.toDataURL('image/jpeg', MAP_JPEG_QUALITY) : undefined;
        }
    } catch {
        return undefined;
    } finally {
        mapContainer.style.height = originalHeight;
    }
};
